/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_Backtohome2Inputs */

const he_contact_success_backtohome2 = /** @type {(inputs: Contact_Success_Backtohome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לדף הבית`)
};

const en_contact_success_backtohome2 = /** @type {(inputs: Contact_Success_Backtohome2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Home`)
};

/**
* | output |
* | --- |
* | "Back to Home" |
*
* @param {Contact_Success_Backtohome2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_success_backtohome2 = /** @type {((inputs?: Contact_Success_Backtohome2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_Backtohome2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_backtohome2(inputs)
	return en_contact_success_backtohome2(inputs)
});
export { contact_success_backtohome2 as "contact_success_backToHome" }